module.exports = __webpack_public_path__ + "img/gq6.20f5a666.png";